import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

// Vue.$vuetify.theme.dark = true;

let mixin = {
  data() {
    return {
      mostrarPrecio: true
    }
  },
  methods: {
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return this.mostrarPrecio ? "$ " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
    }
  }
}

Vue.mixin(mixin);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
